import styled from 'styled-components';

export const StyledSkeleton = styled.div`
  width: 100%;
  min-width: 0;
  min-height: 20rem;
  height: 20rem;
  border-radius: 1px;
  background: linear-gradient(90deg, #1b1c1e 25%, #2a2b2d 50%, #1b1c1e 75%);
  background-size: 200% 100%;
  border: 1px solid rgba(255, 255, 255, 0.05);
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  overflow: hidden;

  @media (min-width: 761px) {
    min-height: 37rem;
    height: 37rem;
    border-radius: 2px;
  }
`;
